<template>
  <footer
    id="footer"
    class="footer"
  >
    <div
      v-show="isShow"
      id="footer-wrap"
      class="footer-wrap"
    >
      <div class="footer-inner">
        <div class="footer-up clearfix">
          <div class="footer-logo fl">
            <!-- 英文 -->
            <img
              v-if="CookiesOne==='en-US'"
              src="./imgs/logo.png"
              alt="DF"
              class="footer__logo"
            />
            <!-- 中文 -->
            <img
              v-if="CookiesOne!=='en-US'"
              src="./imgs/logo.png"
              alt="东福福利网"
              class="footer__logo"
            />
          </div>
          <div
            v-if="footerContent && footerContent.length"
            class="footer-guide fr clearfix"
          >
            <dl
              v-for="foot of footerContent"
              :key="foot.id"
              class="footer-guide__item fl"
            >
              <dt>{{ foot.name }}</dt>
              <dd
                v-for="item of foot.subItems"
                :key="item.id"
              >
                <a
                  :href="
                    item.type === 1
                      ? item.targetLink
                      : `/static/article?id=${item.id}&city=${city}`
                  "
                  :title="item.name"
                  :target="isFeishuOrDingding ? '_self' : '_blank'"
                >{{ item.name }}</a>
              </dd>
            </dl>
          </div>
        </div>
      </div>
      <div class="footer-down tc">
        <p>
          <span>Copyright &copy; 2012–2019
            <a
              :href="`${skipLink}?city=${city}`"
              :target="isFeishuOrDingding ? '_self' : '_blank'"
            >{{TLang('上海东福网络科技有限公司','my')}}.</a>
            All Rights Reserved
            <a
              href="http://www.beian.miit.gov.cn"
              :target="isFeishuOrDingding ? '_self' : '_blank'"
            >{{TLang('沪ICP备16001915号', 'my')}}</a></span>
          <span><a
            :href="`/static/medicalcert?city=${city}`"
            :target="isFeishuOrDingding ? '_self' : '_blank'"
          >{{TLang('第二类医疗器械经营备案凭证','my')}}</a></span>
          <span><a
            :href="`/static/publishcert?city=${city}`"
            :target="isFeishuOrDingding ? '_self' : '_blank'"
          >{{TLang('出版物经营许可证','my')}}</a></span>
        </p>
        <p>
          <span><a
            :href="`/static/winecert?city=${city}`"
            :target="isFeishuOrDingding ? '_self' : '_blank'"
          >{{TLang('酒类商品零售许可证','my')}}</a></span>
          <span><a
            :href="`/static/electriccert?city=${city}`"
            :target="isFeishuOrDingding ? '_self' : '_blank'"
          >{{TLang('增值电信业务经营许可证','my')}}</a></span>
          <span><a
            :href="`/static/privatelegal?city=${city}`"
            :target="isFeishuOrDingding ? '_self' : '_blank'"
          >{{TLang('隐私政策','my')}}</a></span>
          <span>{{TLang('违法和不良信息举报电话','my')}}</span>
          <span><a
            :href="`/static/prePayRule?city=${city}`"
            :target="isFeishuOrDingding ? '_self' : '_blank'"
          >{{TLang('预付卡章程','my')}}</a></span>
        </p>
        <p>
          <span><a
            :target="isFeishuOrDingding ? '_self' : '_blank'"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502004928"
          ><img
            src="./imgs/police@2x.png"
            class="footer-police"
          />{{TLang('沪公网安备','my')}}</a></span>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import { getFooterContent } from './api';
import Cookies from 'js-cookie';
import { unionFlag } from '../../utils';
export default {
  data() {
    return {
      footerContent: [],
      skipLink: '/static/license',
      city: (Cookies.get('address') && JSON.parse(Cookies.get('address') || '{}').cityId) || '145',
      isShow: false,
      CookiesOne:Cookies.get('df_lang'),
    };
  },
  async created() {
    this.getFooterContent();
    try{
      const union = unionFlag() || sessionStorage.getItem('dffl_union');
      if (union) {
        const flag = await this.apis.headerApi.getIsNewUnion();
        if (flag) {
          this.isShow = false;
          document.getElementById('footer').style.display = 'none';
        // document.getElementById("wrapper-inner").style.paddingBottom = "50px";
        } else {
          this.isShow = true;
        }
      } else {
        this.isShow = true;
      }
    }catch(e){
      this.isShow = true;
    }
  },

  methods: {
    async getFooterContent() {
      const res = await getFooterContent({
        location: 3,
      });
      this.footerContent = res ? res.sort((a, b) => a.sort - b.sort) : [];
    },
  },

};
</script>

<style lang="less" scoped>
.footer {
  position: relative;
  height: 330px;
  background-color: #fafafa;
  font: 12px/1.5 Microsoft YaHei, tahoma, arial, "Hiragino Sans GB",
    "\5B8B\4F53", sans-serif;
  color: #333;
  -webkit-font-smoothing: antialiased;
  -moz-font-smoothing: antialiased;
  &-wrap {
    border-top: 1px solid #eee;
    min-width: 1200px;
    box-sizing: border-box;
    height: 210px;
  }
  &-inner {
    display: table;
    height: 100%;
    .wrapper();
  }
  &-guide {
    &__item {
      font-size: 14px;
      float: left;
      margin-right: 80px;
      // width: 130px;
      > dt {
        position: relative;
        &:before {
          content: "";
          position: absolute;
          top: 5px;
          left: -5px;
          width: 2px;
          height: 12px;
          background-color: #333;
        }
      }
      > dd {
        margin-top: 2px;
        > a {
          display: inline-block;
          color: #8d8d8d;
          &:hover {
            color: #619ee0;
          }
        }
      }
      // &:first-child {
      //   width: 170px;
      // }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  &-logo {
    // width: 820px;
    > img {
      width: 510px;
      vertical-align: top;
    }
  }
  &-up {
    display: table-cell;
    vertical-align: middle;
  }
  &-down {
    color: #999;
    padding-top: 12px;
    border-top: 1px solid #eee;
    > p {
      margin-top: 5px;
      > span {
        margin: 0 10px;
      }
    }
    a {
      color: #999;
      cursor: pointer;
      &:hover {
        color: #3d96e2;
      }
    }
  }
  &-police {
    width: 16px;
    vertical-align: top;
    margin-top: 1px;
    margin-right: 3px;
  }
}
</style>
